import { useAllowedUserAgent } from "@/hooks/useAllowedUserAgent";
import { Button } from "@photo-booth/ui/button";
import { ExternalLink } from "lucide-react";

/**
 * Component to display a warning when user is on an unsupported browser
 * Shows a button to open the current page in the default browser
 */
export const UnsupportedBrowserWarning: React.FC = () => {
  const { isAllowed, openInBrowserProps } = useAllowedUserAgent();

  if (isAllowed || !openInBrowserProps) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 space-y-4">
        <div className="space-y-2">
          <Button
            onClick={openInBrowserProps.onClick}
            className="w-full flex items-center justify-center gap-2"
          >
            <ExternalLink className="w-4 h-4" />
            {openInBrowserProps.label}
          </Button>

          <p className="text-xs text-gray-500 text-center">
            This will open the page in your default browser
          </p>
        </div>

        {/* Optional: Copy URL button */}
        <Button
          variant="outline"
          className="w-full"
          onClick={() => {
            navigator.clipboard.writeText(openInBrowserProps.href);
            alert("Link copied! Paste it in your browser.");
          }}
        >
          Copy Link Instead
        </Button>
      </div>
    </div>
  );
};

